import React from "react";
import MDAvatar from "materialDashboard/components/MDAvatar";
import Tooltip from "@mui/material/Tooltip";


const WorkgroupAvatar = ({ workgroup={}, size="sm" }) => {
    const {name} = workgroup;
    const initials = name ? name.split(/[,' ]/).map((n) => n[0]).join("") : "";

    return <Tooltip title={name} placement="bottom" disableInteractive>
        <MDAvatar src={workgroup.icon?.path}
                  size={size}
                  name={name}
                  bgColor={!workgroup.icon?.path ? "secondary" : "transparent"}
                  imgProps={{
                      sx: {
                          width: "16px",
                          height: "16px"
                      }
                  }}>
            {initials}
        </MDAvatar>
    </Tooltip>
}

export default WorkgroupAvatar;